import FileMixin from 'trunks/vue/share/components/fields/file.js';
import FieldMixinForResponse from './mixin.js';

const FileForResponse = {
  mixins: [
    FieldMixinForResponse,
    FileMixin
  ],

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <div class="attachments">
          <div class="attachment-item"
               :class="{ 'uploading': !file.id }"
               v-for='(file, index) in value'
               :key='file.id'
               @click='displayAttachment(file)'>
            <div :class="attachmentWrapperClass(file)">
              <div class="attachment-content content-centered">
                <file-icon :type='file.extension' size='large' v-if='!canPreview(file) && file.id'/>
                <img :src='_thumbnailUrl(file)' v-if='canPreview(file) && file.id'/>
                <div class="btn icon-btn floated btn-large attachment-action" v-if="file._uploadRequest || (!file._error_message && !file.id)">
                  <i class="slp-loading spin"></i>
                </div>
                <div class="btn icon-btn floated btn-large attachment-action" v-if="canReload(file)" @click="reloadFile(index)">
                  <i class="slp-refresh"></i>
                </div>
                <div class="btn icon-btn floated btn-danger btn-small attachment-action delete" v-show='editing' @click.stop='removeFile(index)'>
                  <i class="slp-times"></i>
                </div>
              </div>
            </div>
            <div class="attachment-details">
              <span class="attachment-name text-ellipsis">{{ file.name }}</span>
            </div>
          </div>
          <div class="attachment-item" v-if='editing'>
            <label class="add-file-btn" :class="{'disabled': uploading}">
              <div class="content-centered">
                <input hidden='true' type='file' @change='fileChange' multiple :disabled='uploading'>
                <i class="slp-plus"></i>
                <span class="btn-text">文件上传</span>
              </div>
            </label>
            <div class="attachment-details"></div>
          </div>
        </div>
        <div class="form-field-value empty-attachments placeholder" v-if='!editing && !value.length'>未填写</div>
      </template>
    </Field>
  `,

  methods: {
    displayAttachment: function(attachment) {
      this.$emit('displayAttachment', attachment);
    },

    attachmentWrapperClass: function(file) {
      if (this.canPreview(file)) {
        return 'attachment-preview-container';
      } else {
        return 'attachment-type';
      }
    }
  }
};

export default FileForResponse;
